module.exports = __webpack_public_path__ + "static/img/role0017.d009df1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role0017.jpg
// module id = e8Aw
// module chunks = 1